import React from "react";
import { Container, Flex, Heading, Section } from "@radix-ui/themes";
import { OnePlusOne } from "./1plus1.partner";
import { MHP } from "./mhp.partner";
import { Polpharma } from "./polpharma.partner";
import { OGTSU } from "./ogtsu.partner";
import { Syngenta } from "./syngenta.partner";
import { NovaPoshta } from "./nova-poshta.partner";
import { Hurma } from "./hurma.partner";

import "./styles/partners.css";

export function BarometerPartners() {
  return (
    <Section className="barometer-partners">
      <Container>
        <Heading className="partners-heading" size="8" as="h2">
          Партнери проєкту «Барометр ринку праці 2025»
        </Heading>

        <Flex wrap="wrap" p="5" gap="5" align="stretch" justify="center">
          <OnePlusOne/>
          <MHP/>
          <Polpharma/>
          <OGTSU />
          <Syngenta/>
          <NovaPoshta/>
          <Hurma/>
        </Flex>
      </Container>
    </Section>
  );
}
